import React from 'react';
import { Switch } from 'react-router-dom';
import { paths } from './paths';
import GuardedRoute from '../services/guardedRoute';
import lazyRetry from '../services/lazyRetry';

const PageNotFound = React.lazy(() => lazyRetry(() => import('./pages/PageNotFound')));

const Routes = ({
  isValidUser,
}) => (
  <Switch>
    {paths.map((item) => (
      <GuardedRoute component={item.component} isValidUser={isValidUser || (item.auth != true)} authRequired={item.auth} path={item.route} key={item.route} exact={item.exact} defaultpage={item.defaultpage} />
    ))}
    <GuardedRoute path="*" component={PageNotFound} />
  </Switch>
);

export default Routes;
